import { z } from 'zod';
import {
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';
import { sparkplugAppletNodeCfgDeployParamSchema } from '../../sparkplug-node-cfg.zod';
import { DEFAULT_CONNECTION_ID } from '../../../../../connections/connection-config';

const metricExpressionsSchema = z.array(z.object({
    name: z.string(),
    /**
     * `varValue` type is the default for legacy configs
     */
    dataType: z.union([ z.literal('string'), z.literal('number'), z.literal('boolean'), z.literal('varValue') ]),
}));

type MetricExpressions = z.infer<typeof metricExpressionsSchema>;

export const sparkplugConsumerNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('sparkplugConsumer'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
        connectionId: z.string().default(DEFAULT_CONNECTION_ID),
        configDeploymentParameter: sparkplugAppletNodeCfgDeployParamSchema,
        metricExpressions: z.union([
            z.array(z.string()).transform(arr => arr.map(name => ({ name, dataType: 'varValue' as const }))),
            metricExpressionsSchema,
        ]) as z.ZodType<MetricExpressions>,
    })),
}));
export type SparkplugConsumerNodeCfgSchema = z.infer<typeof sparkplugConsumerNodeCfgSchema>;

export const sparkplugConsumerNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({}),
        outputs: () => ({ event: 'event' }),
    },
    dataSockets: {
        inputs: () => ({}),
        outputs: cfg => {
            // FUTURE: it makes much more sense for these to be keyed by metric name and not index
            const ret: Record<`output${number}`, 'string' | 'number' | 'boolean' | 'varValue'> = {};
            cfg.controlValues.metricExpressions.forEach((m, idx) => {
                ret[`output${idx}`] = m.dataType;
            });
            return ret;
        },
    },
} satisfies NodeSocketCfg<SparkplugConsumerNodeCfgSchema>;
